import styled from "styled-components";

export const StyledLink = styled.a`
  text-decoration: underline;
  color: black;
  cursor: pointer;
`;
